import './index.css';

const DishDetailContainer = ({ children }) => {
    return (
        <div className="dish-detail-container">
            {children}
        </div>
    )
}

export default DishDetailContainer;